import {useQuery} from '@tanstack/react-query'

import {listProjectContacts} from './api'
import {userKeys} from './query-keys'

export function useProjectContacts(options?: {enabled?: boolean}) {
    return useQuery({
        queryKey: userKeys.projectContacts(),
        queryFn: () => listProjectContacts(),
        enabled: options?.enabled ?? true,
    })
}
